import { JackpotModal } from "@shared/components/Modal";
import { useBonuses } from "@shared/hooks/bonuses";
import { useUi } from "@shared/hooks/interface";
import {
  useCooldowns,
  useCurrentWin,
  useSlots,
} from "@shared/hooks/jackpots/jackpots";
import { useLobbyParams } from "@shared/hooks/lobby";
import { useUserBankGroup } from "@shared/hooks/user";
import cx from "classnames";
import { isEmpty } from "lodash-es";
import React, { useEffect, useState } from "react";

// eslint-disable-next-line import/no-named-as-default
import Jackpot from "./Jackpot";

const theme = process.env.REACT_APP_THEME;
const isThemeLuckyClub = theme === "luckyclub";
const ANIMATION_DELAY = 250;

const Jackpots = ({ isCompact }) => {
  const slots = useSlots();
  const win = useCurrentWin();
  const { currency } = useUserBankGroup() ?? "";
  const { bonus } = useBonuses();
  const cooldowns = useCooldowns();
  const [isVisible, setVisible] = useState(false);
  const ui = useUi();
  const { sweepstakes: isSweepstakesEnabled } = useLobbyParams() ?? {};

  const jackpotsElements = {};

  const handleToggleJackpots = () => {
    setVisible((prev) => !prev);
  };

  const animateCooldowns = (cooldowns) => {
    Object.keys(cooldowns).forEach((slot) => {
      const $background = jackpotsElements[slot];

      const show = () => {
        $background.style.height = "";
      };

      const hide = () => {
        $background.style.height = 0;
      };

      const calculateDuration = () => {
        const duration = cooldowns[slot] - Date.now();
        return duration < 0 ? 0 : duration;
      };

      const duration = calculateDuration();
      if (!duration) {
        return show();
      }

      if ($background) {
        $background.style.transitionDuration = `${ANIMATION_DELAY}ms`;
      }

      setTimeout(() => {
        hide();

        setTimeout(() => {
          const duration = calculateDuration();

          $background.style.transitionDuration = `${duration}ms`;
          window.requestAnimationFrame(() => {
            show();
          });
        }, ANIMATION_DELAY);
      }, 0);
    });
  };

  /**
   * @param {HTMLElement} element
   */
  const setJackpotRef = (element) => {
    if (element && element.dataset.slot) {
      jackpotsElements[element.dataset.slot] = element.querySelector(
        ".jackpot__desaturated-image"
      );
    }
  };

  useEffect(() => {
    if (cooldowns) {
      animateCooldowns(cooldowns);
    }
  }, [cooldowns]);

  useEffect(() => {
    window.addEventListener("toggleJackpots:click", () => handleToggleJackpots);
    return () =>
      window.removeEventListener("toggleJackpots:click", handleToggleJackpots);
  }, []);

  if (isEmpty(slots)) {
    return null;
  }

  return (
    <div
      className={cx("jackpots", {
        "jackpots--padding": bonus?.available,
        "jackpots--compact": isCompact,
        "jackpots--visible":
          (isCompact && isVisible) || (isCompact && ui.isJackpotsVisible),
      })}
    >
      {slots.map((slot, index) => (
        <>
          <Jackpot
            ref={setJackpotRef}
            slot={slot}
            index={index}
            key={index}
            currency={isSweepstakesEnabled ? "" : currency}
          />
          {isThemeLuckyClub && index === 1 && <div className="jackpot__logo" />}
        </>
      ))}

      {win && win.id && <JackpotModal />}
    </div>
  );
};

export default Jackpots;
